import { Ico } from "../../lib/icons";
import { Card } from "../../components/atoms";
import { TgScreen } from "../../components/TgScreen";
import { haptic } from "../../lib/haptics";

/**
 * First-launch entry point — shown when no wallet exists.
 * Two CTAs: Create new wallet OR Import existing.
 */
export function WalletSetupSheet({
  onCreate,
  onImport,
  onSkip,
}: {
  onCreate: () => void;
  onImport: () => void;
  /** Lets the user dismiss the prompt and use the app destination-paste-style. */
  onSkip?: () => void;
}) {
  return (
    <TgScreen onClose={onSkip} title="Set up your wallet">
      <div style={{ padding: "12px 16px 24px" }}>
        <Card style={{ padding: 16, marginBottom: 12 }}>
          <div style={{ fontSize: 14, color: "var(--text-soft)", lineHeight: 1.5 }}>
            Shieldz holds your <b style={{ color: "var(--text)" }}>shielded Zcash</b> wallet
            inside Telegram. Keys are encrypted on your device — we never see them, neither does
            Telegram.
          </div>
          <div style={{ height: 0.5, background: "var(--border)", margin: "14px -16px" }} />
          <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
            <Ico.shieldLock style={{ color: "var(--success)", marginTop: 1, flexShrink: 0 }} />
            <div style={{ fontSize: 13, color: "var(--hint)", lineHeight: 1.5 }}>
              <b style={{ color: "var(--text-soft)" }}>Non-custodial.</b> Keys live on your
              device and sync via Telegram. You can back up your recovery phrase any time
              from the Wallet tab.
            </div>
          </div>
        </Card>

        <button
          onClick={() => {
            haptic("medium");
            onCreate();
          }}
          style={{
            width: "100%",
            background: "var(--btn-primary-bg)",
            color: "var(--btn-primary-fg)",
            border: "none",
            borderRadius: 12,
            padding: "14px 16px",
            fontSize: 16,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "var(--font-text)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 10,
          }}
        >
          <span>Get started</span>
          <Ico.chevRight style={{ opacity: 0.7 }} />
        </button>

        <button
          onClick={() => {
            haptic("medium");
            onImport();
          }}
          style={{
            width: "100%",
            background: "var(--bg-2)",
            color: "var(--text)",
            border: "1px solid var(--hairline)",
            borderRadius: 12,
            padding: "14px 16px",
            fontSize: 15,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "var(--font-text)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>I have a 12-word phrase</span>
          <Ico.chevRight style={{ opacity: 0.7, color: "var(--hint)" }} />
        </button>

        {onSkip && (
          <div style={{ textAlign: "center", paddingTop: 18 }}>
            <button
              onClick={() => {
                haptic("light");
                onSkip();
              }}
              style={{
                background: "none",
                border: "none",
                color: "var(--hint)",
                fontSize: 13,
                fontWeight: 500,
                cursor: "pointer",
                fontFamily: "var(--font-text)",
              }}
            >
              Skip — I'll paste an address each swap
            </button>
          </div>
        )}
      </div>
    </TgScreen>
  );
}
